module.exports = "/images/arrow-down-black.svg?5d923791435167bdd80665a2e7548f04";